<template>
  <section class="das-form-container">
    <div class="das-form-group">
      <div class="das-form-group-title">Chi tiết đặt phòng</div>
      <div class="das-layout gap-20">
        <div class="l-w-50">
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="">
                <div class="label required">
                  {{ 'Master' }}
                </div>
                <div class="checkbox-wrap">
                  <input
                    id="is_master"
                    v-model="formData.is_master"
                    :disabled="isEditCheckedIn"
                    type="checkbox"
                  />
                  <label for="is_master">
                    {{ 'Master' }}
                  </label>
                </div>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="">
                <div class="label required">
                  {{ 'Trong ngày' }}
                </div>
                <div class="checkbox-wrap">
                  <input
                    id="hour_stay"
                    v-model="formData.hour_stay"
                    :disabled="isEditCheckedIn"
                    type="checkbox"
                    @input="onChangeHourStay"
                  />
                  <label for="hour_stay">
                    {{ 'Trong ngày' }}
                  </label>
                </div>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="">
                <div class="label">
                  {{ $t('field.amountOfNight') }}
                </div>
                <validation-provider
                  :name="$t('field.amountOfNight')"
                  rules="required|number|min_value:0"
                >
                  <input
                    v-model="numberOfNights"
                    v-numeric-only
                    type="number"
                    disabled
                  />
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="">
                <div class="label required">
                  {{ $t('field.checkInDate') }}
                </div>
                <div class="das-layout gap-10">
                  <div class="l-w-66">
                    <CalendarSelect
                      v-model="formData.arrive_date"
                      mode="date"
                      :disabled="isEditCheckedIn"
                      :min-max="{ min: minDate }"
                    />
                  </div>
                  <div class="l-w-33">
                    <TimePicker
                      v-model="formData.arrive_time"
                      :disabled="isEditCheckedIn"
                      format="HH:mm"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="">
                <div class="label required">
                  {{ $t('field.checkOutDate') }}
                </div>
                <div class="das-layout gap-10">
                  <div class="l-w-66">
                    <CalendarSelect
                      v-model="formData.depart_date"
                      mode="date"
                      :disabled="isEditCheckedIn"
                      :min-max="{
                        min: formData.arrive_date,
                        max: maxDepartDate
                      }"
                    />
                  </div>
                  <div class="l-w-33">
                    <TimePicker
                      v-model="formData.depart_time"
                      :disabled="isEditCheckedIn"
                      format="HH:mm"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <el-row :gutter="8" class="">
                <el-col :span="6">
                  <div class="label das-label das-label--required">
                    {{ $t('field.numOfAdult') }}
                  </div>
                  <validation-provider
                    :name="$t('field.numOfAdult')"
                    rules="required|number|min_value:0"
                  >
                    <input
                      v-model.number="formData.num_of_guest"
                      v-numeric-only
                      type="number"
                    />
                  </validation-provider>
                </el-col>
                <el-col :span="6">
                  <div class="label das-label">
                    {{ $t('field.numOfChildren') }}
                  </div>
                  <input
                    v-model.number="formData.child_num"
                    v-numeric-only
                    type="number"
                  />
                </el-col>
                <el-col :span="6">
                  <div class="label das-label">Trẻ em dưới 5 tuổi</div>
                  <input
                    v-model.number="formData.u5_child_num"
                    v-numeric-only
                    type="number"
                  />
                </el-col>
                <el-col :span="6">
                  <div class="label">Tổng số khách</div>
                  <input disabled :value="totalGuestsNumber" type="number" />
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <el-row :gutter="8">
                <el-col :span="3">
                  <div class="label">
                    {{ 'Combo' }}
                  </div>
                  <div class="checkbox-wrap">
                    <input
                      id="combo"
                      v-model="formData.is_combo"
                      :disabled="isDisableCombo || isEditCheckedIn"
                      type="checkbox"
                      @change="onChangeEnableCombo"
                    />
                    <label for="combo">
                      <!-- {{ 'Combo' }} -->
                    </label>
                  </div>
                </el-col>
                <el-col :span="6">
                  <!-- <div class="label das-label das-label--required required">
                    {{ 'Tiền tệ' }}
                  </div>
                  <el-select
                    v-model.number="formData.currency_id"
                    :disabled="isEditCheckedIn"
                    :default-first-option="true"
                    @change="onChangeCurrency"
                  >
                    <el-option
                      v-for="option in currencyOptions"
                      :key="option.id"
                      :label="option.code"
                      :value="option.id"
                    >
                    </el-option>
                  </el-select> -->
                  <div class="label das-label">
                    {{ 'Ngày áp dụng' }}
                  </div>
                  <CalendarSelect
                    v-model="formData.package_group.apply_date"
                    mode="date"
                    :disabled="!formData.is_combo || isEditCheckedIn"
                    :min-max="{
                      min: formData.arrive_date,
                      max: theDayBeforeDepartDate
                    }"
                    @input="onApplyDateChange"
                  />
                </el-col>
                <el-col :span="5">
                  <!-- <div class="label">
                    {{ 'Tỉ giá' }}
                  </div>
                  <input
                    v-model.number="formData.exchange_rate"
                    :disabled="isEditCheckedIn"
                    type="number"
                    step="0.1"
                  /> -->
                  <div class="label das-label">
                    {{ 'Combo' }}
                  </div>
                  <el-select
                    v-model.number="formData.package_group.package_group_id"
                    :default-first-option="true"
                    :disabled="!formData.is_combo || isEditCheckedIn"
                    @change="onChangeCombo"
                  >
                    <el-option
                      v-for="option in comboOptions"
                      :key="option.id"
                      :label="option.code"
                      :value="option.id"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="5">
                  <div class="label">
                    {{ 'SL NL' }}
                  </div>
                  <input
                    v-model.number="formData.package_group.number_of_adults"
                    v-numeric-only
                    :disabled="!formData.is_combo || isEditCheckedIn"
                    type="number"
                    :max="formData.num_of_guest"
                  />
                </el-col>
                <el-col :span="5">
                  <div class="label">
                    {{ 'SL TE' }}
                  </div>
                  <input
                    v-model.number="formData.package_group.number_of_children"
                    v-numeric-only
                    type="number"
                    :disabled="!formData.is_combo || isEditCheckedIn"
                    :max="formData.child_num"
                  />
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div class="l-w-50">
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="">
                <div class="label">Khách sạn</div>
                <el-select
                  v-model="hotel_id"
                  :disabled="isEditCheckedIn"
                  filterable
                  clearable
                  @change="onChangeHotel"
                >
                  <el-option
                    v-for="option in hotelOptions"
                    :key="option.id"
                    :label="option.name"
                    :value="option.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="">
                <div class="label required das-label das-label--required">
                  {{ $t('field.bookedRoomLevel') }}
                </div>
                <select-with-search-table
                  :disabled="isEditCheckedIn"
                  style="width: 100%"
                  :suppress-row-hover-highlight="true"
                  :rows="filteredRoomLevelOptions"
                  :columns="roomLevelOptionsCol"
                  row-class="room-level-row"
                  :get-row-class="getRowClass"
                  :search-fields="['room_type_name', 'room_level_code']"
                  :value="formData.room_type_id"
                  :selected-index-field-value="formData.room_type_id"
                  index-field="room_level_id"
                  @selectionChanged="onChangeRoomLevel"
                >
                  <template v-slot:value="{ selectedValue: selectedData }">
                    {{ selectedData?.room_type_name }}
                  </template>
                </select-with-search-table>
              </div>
            </div>
          </div>
          <div v-if="formData.rowIndex !== null" class="das-form-row">
            <div class="das-form-col col-12">
              <div class="">
                <div class="label">
                  {{ $t('field.roomBooking') }}
                </div>
                <div class="input-group">
                  <input
                    :disabled="isEditCheckedIn"
                    :value="selectedRoom?.room_num"
                    type="text"
                    @click="onOpenSelectRoomDialog"
                  />
                  <div class="input-group__append input-group-btn">
                    <button @click="onRemoveRoom">
                      <i class="el-icon-delete"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="das-form-row">
            <div class="das-form-col col-12">
              <div class="label">
                {{ 'Số phòng' }}
              </div>
              <input
                v-model="formData.num_of_room"
                v-numeric-only
                :disabled="isEditCheckedIn"
                type="text"
                placeholder="Số lượng phòng đặt"
              />
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="label das-label">Số thẻ miễn phí</div>
              <input
                v-model.number="formData.num_of_free_card"
                v-numeric-only
                type="number"
                readonly
              />
              <!-- :disabled="isEditCheckedIn" -->
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="label">
                {{ 'Miễn phí/Nội bộ' }}
              </div>
              <el-select
                v-model="formData.price_type"
                :disabled="isEditCheckedIn"
                clearable
              >
                <el-option :value="1" label="Miễn phí"></el-option>
                <el-option :value="2" label="Nội bộ"></el-option>
              </el-select>
            </div>
            <div class="das-form-col col-9">
              <div class="">
                <div class="label">
                  {{ 'Khác' }}
                </div>
                <div class="das-layout gap-10">
                  <div class="checkbox-wrap l-w-50">
                    <input
                      id="lockChangeRoom"
                      v-model="formData.block_room"
                      :disabled="!canLockTransferRoom || isEditCheckedIn"
                      type="checkbox"
                    />
                    <label for="lockChangeRoom">
                      {{ $t('field.lockChangeRoom') }}
                    </label>
                  </div>
                  <!-- <div class="checkbox-wrap">
                  <input
                    id="notPrintPrice"
                    v-model="formData.no_price_printing"
                    type="checkbox"
                  />
                  <label for="notPrintPrice">
                    {{ $t('field.notPrintPrice') }}
                  </label>
                </div> -->
                  <!-- <div class="l-w-50 flex align-center">
                    <div class="flex align-center" style="gap: 20px">

                      <div class="checkbox-wrap">
                        <input
                          id="nett"
                          v-model="formData.nett"
                          :disabled="isEditCheckedIn"
                          type="checkbox"
                        />
                        <label for="nett">
                          {{ 'NETT' }}
                        </label>
                      </div>
                    </div>
                  </div> -->
                  <div class="l-w-50 flex align-center">
                    <div class="flex align-center" style="gap: 20px">
                      <div class="checkbox-wrap">
                        <input
                          id="buffet"
                          v-model="formData.is_bf"
                          type="checkbox"
                          :disabled="isBuffetDisabled || isEditCheckedIn"
                          @change="onChangeBuffet"
                        />
                        <label for="buffet">
                          {{ 'Buffet' }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <!--                   <div class="checkbox-wrap l-w-50">
                    <input
                      id="notAddService"
                      v-model="formData.no_extra_service"
                      type="checkbox"
                    />
                    <label for="notAddService">
                      {{ $t('field.notAddService') }}
                    </label>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="das-form-group">
      <div class="das-form-group-title">Giá ngày</div>
      <BookingRoomDailyPriceTable
        ref="BookingRoomDailyPriceTable"
        :key="`daily-price-${formData.room_type_id}-${formData.daily_price?.length || 0}`"
        :disabled="isEditCheckedIn"
        :record-rows="formData.daily_price"
        @updateRow="onUpdateDailyPriceRow"
      ></BookingRoomDailyPriceTable>
    </div>
    <hr />
    <div class="das-form-group">
      <div class="justify-space-between">
        <label for="" class="mr-10 das-form-group-title">Phụ thu phí</label>
        <!-- :hidden="!canAddRoomService" -->
        <button
          class="btn small primary outline"
          style="margin-bottom: 8px"
          @click="onOpenBookingAddChargeDialog"
        >
          Chỉnh sửa
        </button>
      </div>
      <booking-room-add-charge-table
        :key="`surcharges-${formData.room_type_id}-${formData.sub_booking_group_surcharges?.length || 0}`"
        :record-rows="formData.sub_booking_group_surcharges"
      ></booking-room-add-charge-table>
      <el-dialog
        append-to-body
        :title="$t('field.addCharge')"
        :visible.sync="isAddChargeDialogOpened"
        :close-on-click-modal="false"
        width="80%"
        @closed="isAddChargeDialogOpened = false"
      >
        <booking-room-add-charge-dialog
          v-if="isAddChargeDialogOpened"
          :key="formData.room_type_id"
          ref="BookingRoomAddChargeDialog"
          :arrive-date="formData.arrive_date"
          :depart-date="formData.depart_date"
          :room-level-id="formData.room_type_id"
          :booking-room="formData"
        ></booking-room-add-charge-dialog>
        <span
          slot="footer"
          class="dialog-footer"
          style="display: flex; gap: 10px; justify-content: flex-end"
        >
          <button class="btn primary small" @click="onConfirmAddCharge">
            Cập nhật
          </button>
          <button
            class="btn primary small outline"
            @click="isAddChargeDialogOpened = false"
          >
            Đóng
          </button>
        </span>
      </el-dialog>
    </div>
    <hr />
    <div class="das-form-group">
      <div class="justify-space-between">
        <label for="" class="mr-10 das-form-group-title"
          >Dịch vụ đặc biệt</label
        >
        <button
          :hidden="!canAddRoomService"
          class="btn small primary outline"
          style="margin-bottom: 8px"
          @click="onOpenBookingRoomServiceDialog"
        >
          Chỉnh sửa
        </button>
      </div>
      <BookingRoomServiceTable
        :key="`services-${formData.room_type_id}-${formData.sub_booking_group_services?.length || 0}`"
        :record-rows="formData.sub_booking_group_services"
      ></BookingRoomServiceTable>
      <el-dialog
        append-to-body
        :title="$t('field.titleSpecialService')"
        :visible.sync="isServiceDialogOpened"
        :close-on-click-modal="false"
        width="80%"
        @closed="isServiceDialogOpened = false"
      >
        <BookingRoomServiceDialog
          v-if="isServiceDialogOpened"
          ref="BookingRoomServiceDialog"
          :arrive-date="formData.arrive_date"
          :depart-date="formData.depart_date"
          :booking-room="formData"
        ></BookingRoomServiceDialog>
        <span
          slot="footer"
          class="dialog-footer"
          style="display: flex; gap: 10px; justify-content: flex-end"
        >
          <button class="btn primary small" @click="onConfirmService">
            Cập nhật
          </button>
          <button
            class="btn primary small outline"
            @click="isServiceDialogOpened = false"
          >
            Đóng
          </button>
        </span>
      </el-dialog>
    </div>

    <BookingRoomSelectRoomDialog
      v-if="isSelectRoomDialogOpened"
      :selected-data="{
        roomNumber: null,
        hotelId: hotel_id,
        roomLevelId: formData.room_type_id,
        arriveDate: formData.arrive_date,
        departDate: formData.depart_date,
        depart_time: formData.depart_time,
        arrive_time: formData.arrive_time
      }"
      :excluded-room-ids="excludedRoomIds"
      :hotels="hotelOptions"
      @close="isSelectRoomDialogOpened = false"
      @roomSelected="onRoomSelected"
    ></BookingRoomSelectRoomDialog>
  </section>
</template>
<script>
/* eslint-disable */
import { checkAuthorized } from '@/utils/helper'

import { getBookingGroupAvailableRoomLevelListApi } from '@/api/booking_service/bookingGroupApi'
import { getAllHotels } from '@/api/configuration/hotel/hotel'
import { getAllCurrencyApi } from '@/api/common/currency'
import {
  getRoomListApi,
  getComboListApi
} from '@/api/booking_service/bookingGroup'
import BookingRoomServiceTable from '@/components/resources/booking/BookingRoomServiceTable.vue'
import BookingRoomAddChargeTable from '@/components/resources/booking/BookingRoomAddChargeTable.vue'
import BookingRoomDailyPriceTable from '@/components/resources/booking/BookingRoomDailyPriceTable.vue'
import BookingRoomServiceDialog from '@/components/resources/booking/BookingRoomServiceDialog.vue'
import BookingRoomAddChargeDialog from '@/components/resources/booking/BookingRoomAddChargeDialog.vue'
import BookingRoomSelectRoomDialog from '@/components/resources/booking/BookingRoomSelectRoomDialog.vue'
import { generateDailyPriceApi } from '@/api/booking_service/booking'
import { newDateFromLocal } from '@/utils/date'
export default {
  components: {
    BookingRoomSelectRoomDialog,
    BookingRoomServiceDialog,
    BookingRoomDailyPriceTable,
    BookingRoomServiceTable,
    BookingRoomAddChargeTable,
    BookingRoomAddChargeDialog
  },
  props: {
    action: {
      default: () => 'create',
      validator(value) {
        return ['create', 'edit', 'view', 'edit-checked-in'].includes(value)
      }
    },
    recordData: null,
    excludedRoomIds: {
      default: () => []
    },
    promotionInfo: {
      type: Object,
      default: () => null
    },
    voucherInfo: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isHydrated: false,
      isServiceDialogOpened: false,
      isAddChargeDialogOpened: false,
      isSelectRoomDialogOpened: false,
      hotel_id: null,
      selectedRoom: null,
      minDate: newDateFromLocal(new Date()),

      formData: {
        id: null,
        hour_stay: false,
        daily_price: [],
        num_of_guest: null,
        num_of_night: 1,
        num_of_room: null,
        room_type_id: null,
        arrive_date: this.$moment(newDateFromLocal(new Date())).format(
          'YYYY-MM-DD'
        ),
        depart_date: this.$moment(newDateFromLocal(new Date()))
          .add(1, 'days')
          .format('YYYY-MM-DD'),
        arrive_time: {
          HH: '14',
          mm: '00'
        },
        depart_time: {
          HH: '12',
          mm: '00'
        },

        child_num: null,
        u5_child_num: null,
        room_id: null,
        price_type: null,
        block_room: false,
        is_master: null,
        is_combo: false,
        package_group: {
          package_group_id: null,
          number_of_adults: 0,
          number_of_children: 0,
          apply_date: null,
          child_price: 0,
          adult_price: 0
        },

        room_type_code: null,
        room_num: null,
        nett: true,
        price: null,
        room: null,
        is_bf: true,
        num_of_free_card: null,

        currency_id: null,
        currency_code: null,
        exchange_rate: null,
        discount_reason: null,
        percent_discount: null,
        amount_discount: null,

        no_price_printing: false,
        no_extra_service: false,
        sub_booking_group_services: [],
        sub_booking_group_surcharges: []
      },
      hotelOptions: [],
      roomTypeOptions: [],
      roomLevelOptions: [],
      roomOptions: [],
      currencyOptions: [],
      comboOptions: [],

      // selectedCombo: null,
      rootdailyPrice: null,

      roomLevelOptionsCol: [
        {
          headerName: 'Tên',
          field: 'room_type_name',
          // cellClass: "grid-cell-centered",
          flex: 2
        },
        {
          headerName: 'Số phòng',
          field: 'total_room',
          // cellClass: "grid-cell-centered",
          flex: 2
        },
        {
          headerName: 'Số phòng trống',
          field: 'room_available_num',
          // cellClass: "grid-cell-centered",
          flex: 3
        }
      ],
      roomOptionsColumns: []
    }
  },
  computed: {
    isEditCheckedIn() {
      return this.action === 'edit-checked-in'
    },
    isBuffetDisabled() {
      return this.hotel_id !== 45
    },
    canLockTransferRoom() {
      return checkAuthorized('LOCK_TRANSFER_ROOM')
    },
    canAddRoomService() {
      // return checkAuthorized('TRANSACTION_ADD_ROOM_SERVICE_GROUP')
      return true
    },
    filteredRoomLevelOptions() {
      if (this.hotel_id == null || this.hotel_id === '') {
        return this.roomLevelOptions
      }
      return this.roomLevelOptions.filter(
        room => room.hotel_id === this.hotel_id
      )
    },
    numberOfNights() {
      const oneDay = 24 * 60 * 60 * 1000

      const numberOfNight = Math.round(
        Math.abs(
          (new Date(this.formData.depart_date) -
            new Date(this.formData.arrive_date)) /
            oneDay
        )
      )
      return numberOfNight === 0 ? 1 : numberOfNight
    },
    maxDepartDate() {
      return this.formData.hour_stay === false
        ? null
        : this.$moment(this.formData.arrive_date).add(1, 'd').toDate()
    },
    totalGuestsNumber() {
      return (
        Number(this.formData.num_of_guest) +
        Number(this.formData.u5_child_num) +
        Number(this.formData.child_num)
      )
    },
    completeComboInfo() {
      return `
        ${this.formData.is_combo}|
        ${this.formData.applyDate}|
        ${this.formData.package_group.package_group_id}|
        ${this.formData.package_group.number_of_adults}|
        ${this.formData.package_group.number_of_children}
      `
    },
    isDisableCombo() {
      return (
        this.formData.hour_stay ||
        this.formData.arrive_date === this.formData.depart_date ||
        this.formData.room_type_id === null ||
        !this.guestNumCondition
      )
    },
    guestNumCondition() {
      // console.log('ao vay')
      if (this.selectedRoomType === null) return false
      return (
        (this.formData.num_of_guest || 0) * 2 >=
        this.selectedRoomType.people_num
      )
    },
    theDayBeforeDepartDate() {
      return this.formData.depart_date
        ? this.$moment(this.formData.depart_date, 'YYYY-MM-DD')
            .subtract(1, 'days')
            .format('YYYY-MM-DD')
        : null
    },
    selectedCombo() {
      return this.comboOptions
        ? this.comboOptions.filter(
            item => item.id === this.formData.package_group.package_group_id
          )[0] || null
        : null
    },
    selectedRoomType() {
      // console.log('hehe', this.roomLevelOptions, this.formData.room_type_id)
      return (
        this.roomLevelOptions.filter(item => {
          return item.room_level_id === this.formData.room_type_id
        })[0] || null
      )
    },
    discountSourceName() {
      if (this.promotionInfo && this.promotionInfo.name) {
        return `Promotion: ${this.promotionInfo.name}`
      }
      if (this.voucherInfo && this.voucherInfo.length > 0) {
        const voucherNames = this.voucherInfo.map(v => v.name || v.code).join(', ')
        return `Voucher: ${voucherNames}`
      }
      return ''
    }
  },
  watch: {
    guestNumCondition: {
      handler() {
        if (!this.guestNumCondition) {
          this.formData.is_combo = false
          this.formData.package_group = {
            package_group_id: null,
            number_of_adults: 0,
            number_of_children: 0,
            apply_date: null
          }
        }
      }
    },
    promotionInfo: {
      handler() {
        this.updateDiscountReason()
      },
      deep: true
    },
    voucherInfo: {
      handler() {
        this.updateDiscountReason()
      },
      deep: true
    },
    'formData.arrive_date': {
      handler() {
        if (this.formData.depart_date < this.formData.arrive_date) {
          this.formData.depart_date = this.$moment(this.formData.arrive_date)
            .add(1, 'days')
            .format('YYYY-MM-DD')
        }
        this.onChangeBookingDate()
        // Emit event để sync arrive_date và depart_date lên parent
        this.$emit('bookingDatesUpdated', {
          arrive_date: `${this.formData.arrive_date} ${this.formData.arrive_time.HH}:${this.formData.arrive_time.mm}`,
          depart_date: `${this.formData.depart_date} ${this.formData.depart_time.HH}:${this.formData.depart_time.mm}`
        })
      }
    },
    'formData.depart_date': {
      handler() {
        this.onChangeBookingDate()
        // Emit event để sync arrive_date và depart_date lên parent
        this.$emit('bookingDatesUpdated', {
          arrive_date: `${this.formData.arrive_date} ${this.formData.arrive_time.HH}:${this.formData.arrive_time.mm}`,
          depart_date: `${this.formData.depart_date} ${this.formData.depart_time.HH}:${this.formData.depart_time.mm}`
        })
      }
    },
    'formData.arrive_time': {
      handler() {
        this.onChangeBookingDate()
        // Emit event để sync arrive_date và depart_date lên parent
        this.$emit('bookingDatesUpdated', {
          arrive_date: `${this.formData.arrive_date} ${this.formData.arrive_time.HH}:${this.formData.arrive_time.mm}`,
          depart_date: `${this.formData.depart_date} ${this.formData.depart_time.HH}:${this.formData.depart_time.mm}`
        })
      },
      deep: true
    },
    'formData.depart_time': {
      handler() {
        this.onChangeBookingDate()
        // Emit event để sync arrive_date và depart_date lên parent
        this.$emit('bookingDatesUpdated', {
          arrive_date: `${this.formData.arrive_date} ${this.formData.arrive_time.HH}:${this.formData.arrive_time.mm}`,
          depart_date: `${this.formData.depart_date} ${this.formData.depart_time.HH}:${this.formData.depart_time.mm}`
        })
      },
      deep: true
    },
    completeComboInfo: {
      handler() {
        // this.onChangeBookingDate()
        const check =
          // this.selectedCombo &&
          this.formData.is_combo &&
          this.formData.applyDate !== null &&
          this.formData.package_group.package_group_id !== null &&
          ((!isNaN(this.formData.package_group.number_of_adults) &&
            this.formData.package_group.number_of_adults > 0) ||
            (!isNaN(this.formData.package_group.number_of_children) &&
              this.formData.package_group.number_of_children > 0))
        if (check) {
          const currAppIdx = this.formData.daily_price.findIndex(
            item => item.date === this.formData.package_group.apply_date
          )
          var idx = currAppIdx
          // var idx = -1
          // var max = 0
          // this.rootdailyPrice
          //   .slice(currAppIdx, currAppIdx + 2)
          //   .map((item, index) => {
          //     if (max < item.price) {
          //       max = item.price
          //       idx = index + currAppIdx
          //     }
          //   })
          if (idx >= 0) {
            if (this.selectedCombo) {
              const money =
                Number(this.selectedCombo.adult_price) *
                  (this.formData.package_group.number_of_adults || 0) +
                Number(this.selectedCombo.child_price) *
                  (this.formData.package_group.number_of_children || 0)
              this.formData.package_group.child_price = Number(
                this.selectedCombo.child_price
              )
              this.formData.package_group.adult_price = Number(
                this.selectedCombo.adult_price
              )
              // console.log('trong watchhh', this.formData.package_group)
              this.$set(this.formData.daily_price[idx], 'price', money)
              this.$refs.BookingRoomDailyPriceTable.$refs.agGrid.gridOptions.api.refreshCells(
                {
                  force: true
                }
              )
              // Emit event để sync dữ liệu lên parent
              this.$emit('dailyPriceUpdated', JSON.parse(JSON.stringify(this.formData.daily_price)))
            }
          }
        } else {
          if (this.rootdailyPrice) {
            this.formData.daily_price =
              this.rootdailyPrice.map(item => {
                return Object.assign({}, { ...item }) || []
              }) || []
            // Emit event để sync dữ liệu lên parent
            this.$emit('dailyPriceUpdated', JSON.parse(JSON.stringify(this.formData.daily_price)))
          }
        }
      }
    }
  },
  async created() {
    this.isHydrated = false
    await this.hydrateForm(this.recordData)
    if (
      this.action === 'edit' ||
      this.action === 'view' ||
      this.action === 'edit-checked-in'
    ) {
      this.formData.package_group.package_group_id =
        this.recordData?.package_group?.package_group_id
    }
    await Promise.all([
      this.getHotelOptions(),
      this.getCurrencyOptions(),
      this.getRoomTypeOptions(
        `${this.formData.arrive_date} ${this.formData.arrive_time.HH}:${this.formData.arrive_time.mm}`,
        `${this.formData.depart_date} ${this.formData.depart_time.HH}:${this.formData.depart_time.mm}`
      )
    ]).then(() => {
      if (
        this.action === 'edit' ||
        this.action === 'view' ||
        this.action === 'edit-checked-in'
      ) {
        this.formData.num_of_free_card =
          this.roomLevelOptions?.find(
            item => item.room_level_id == this.formData?.room_type_id
          )?.free_card_quantity ?? this.formData.free_card_quantity
      }
    })

    /*
      Add this to update daily price when default
      form values is passed from Room Schedule page
    */
    if (this.totalGuestsNumber === 0 && this.formData.room_type_id) {
      this.getDailyPrice()
    }
    if (this.recordData?.daily_price.length > 0) {
      await generateDailyPriceApi(
        this.recordData.arrive_date,
        this.recordData.depart_date,
        this.recordData.room_type_id,
        this.recordData.is_bf
      ).then(res => {
        this.rootdailyPrice = res.data.map(day => {
          return {
            id: 0,
            price: day.price,
            date: day.date,
            note: null,
            price_code_id: day.price_code_id,
            price_code: day.price_code,
            nett: day.nett,
            currency_id: day.currency_id,
            currency_code: day.currency_code,
            exchange_rate: day.exchange_rate,
            percent_discount: day.percent_discount,
            amount_discount: day.amount_discount,
            discount_reason: this.discountSourceName || day.discount_reason
          }
        })
      })
    }
    this.isHydrated = true
    // console.log('trong createeee', this.formData.package_group)
  },
  mounted() {
    // console.log(this.$moment().tz('Asia/Ho_Chi_Minh').format('YYYY-MM-DD'))
  },
  methods: {
    onChangeBuffet() {
      if (
        this.formData.room_type_id &&
        this.formData.arrive_date &&
        this.formData.depart_date
      ) {
        this.getDailyPrice()
      }
    },
    getRowClass(params) {
      let color = null

      const hotelId = params.data.hotel_id
      switch (hotelId) {
        // Khách sạn đoàn tàu
        case 46:
          color = 'green'
          break
        // Khu cắm trại
        case 45:
          color = 'yellow'
          break
        // Làng cổ tích
        case 44:
          color = 'red'
          break
        // Nebula
        case 47:
          color = 'purple'
          break
        // Nhà sàn thái
        case 48:
        default:
          color = 'brown'
          break
      }
      return 'room-level-row room-level-row--' + color
    },
    onUpdateDailyPriceRow(colName, params, value) {
      const rowIndex = params.rowIndex
      const fieldName = params.colDef.field

      // Cập nhật dữ liệu với Vue reactivity
      this.$set(this.formData.daily_price[rowIndex], fieldName, value)

      // Cập nhật discount_reason với thông tin promotion/voucher
      // Chỉ cập nhật nếu có giảm giá thực sự
      if (this.discountSourceName && (this.formData.daily_price[rowIndex]['amount_discount'] || this.formData.daily_price[rowIndex]['percent_discount'])) {
        this.$set(this.formData.daily_price[rowIndex], 'discount_reason', this.discountSourceName)
      } else if (!this.formData.daily_price[rowIndex]['amount_discount'] && !this.formData.daily_price[rowIndex]['percent_discount']) {
        // Nếu không có giảm giá, để trống lý do giảm giá
        this.$set(this.formData.daily_price[rowIndex], 'discount_reason', null)
      }

      // Emit event để parent component (BookingFormBookingTab) có thể sync dữ liệu
      // Vì BookingRoomForm nằm trong el-dialog với append-to-body nên $parent không hoạt động
      this.$emit('dailyPriceUpdated', JSON.parse(JSON.stringify(this.formData.daily_price)))
    },
    async onRoomSelected(room) {
      if (!this.isHydrated) {
        return
      }
      // TODO: Check this with backend for consistent type for ID
      console.log('check room', room)
      const room_level_id = parseInt(room.room_level_id)
      const isRoomLevelChanged = this.formData.room_type_id !== room_level_id
      this.formData.room_id = room.room_id
      this.hotel_id = room.hotel_id
      this.selectedRoom = room
      this.isSelectRoomDialogOpened = false
      this.formData.num_of_guest = room.people_num

      if (isRoomLevelChanged) {
        this.formData.room_type_id = room_level_id
        this.formData.num_of_free_card = this.filteredRoomLevelOptions.find(
          item => item.room_level_id == room_level_id
        )?.free_card_quantity
        await this.getDailyPrice()
      }
    },
    onOpenSelectRoomDialog() {
      this.isSelectRoomDialogOpened = true
    },
    onOpenBookingRoomServiceDialog() {
      this.isServiceDialogOpened = true
    },
    onOpenBookingAddChargeDialog() {
      this.isAddChargeDialogOpened = true
    },
    onConfirmService() {
      const payload = this.$refs.BookingRoomServiceDialog.dehydrateTable()
      if (this.action === 'edit-checked-in') {
        payload.forEach((el, index) => {
          if (index < this.formData.sub_booking_group_services.length) {
            return
          }
          el.isAdded = true
        })
      }

      // Cập nhật dữ liệu local với Vue reactivity
      this.$set(this.formData, 'sub_booking_group_services', payload)

      // Emit event để parent component (BookingFormBookingTab) có thể sync dữ liệu
      // Vì BookingRoomForm nằm trong el-dialog với append-to-body nên $parent không hoạt động
      this.$emit('servicesUpdated', JSON.parse(JSON.stringify(payload)))
      this.isServiceDialogOpened = false
    },
    onConfirmAddCharge() {
      const payload = this.$refs.BookingRoomAddChargeDialog.dehydrateTable()
      if (this.action === 'edit-checked-in') {
        payload.forEach((el, index) => {
          if (index < this.formData.sub_booking_group_surcharges.length) {
            return
          }
          el.isAdded = true
        })
      }

      // Cập nhật dữ liệu local với Vue reactivity
      this.$set(this.formData, 'sub_booking_group_surcharges', payload)

      // Emit event để parent component (BookingFormBookingTab) có thể sync dữ liệu
      // Vì BookingRoomForm nằm trong el-dialog với append-to-body nên $parent không hoạt động
      this.$emit('surchargesUpdated', JSON.parse(JSON.stringify(payload)))
      
      this.isAddChargeDialogOpened = false
    },
    dehydrateForm(shouldFilterAdded = true) {
      const roomType = this.roomLevelOptions.find(
        e => e.room_level_id === this.formData.room_type_id
      )
      // const currency_code = this.currencyOptions.find(
      //   e => e.id === this.formData.currency_id
      // ).code

      const payload = JSON.parse(JSON.stringify(this.formData))
      payload.hotel_id = this.hotel_id
      payload.arrive_date = `${this.formData.arrive_date} ${this.formData.arrive_time.HH}:${this.formData.arrive_time.mm}`
      payload.depart_date = `${this.formData.depart_date} ${this.formData.depart_time.HH}:${this.formData.depart_time.mm}`
      payload.num_of_night = this.numberOfNights
      payload.room_type_name = roomType?.room_type_name
      payload.room_num = this.selectedRoom?.room_num
      // payload.currency_code = currency_code
      if (
        this.$moment
          .duration(
            this.$moment(payload.depart_date).diff(
              this.$moment(payload.arrive_date)
            )
          )
          .asHours() < 0
      ) {
        this.$message({
          type: 'error',
          message: 'Ngày đi phải sau ngày đến'
        })
        return
      }

      if (this.formData.status === 2 && shouldFilterAdded) {
        payload.sub_booking_group_services =
          payload.sub_booking_group_services.filter(el => el.isAdded)
        payload.sub_booking_group_surcharges =
          payload.sub_booking_group_surcharges.filter(el => el.isAdded)
      }
      if (this.formData.is_combo != true) {
        payload.package_group = null
      }
      return payload
    },
    async hydrateForm(recordData = null) {
      if (recordData == null) {
        return
      }
      Object.assign(this.formData, {
        ...recordData,
        package_group: { ...recordData.package_group }
      })
      const arriveTime = this.$moment(this.recordData.arrive_date)
      const departTime = this.$moment(this.recordData.depart_date)
      this.formData.arrive_date = arriveTime.format('YYYY-MM-DD')
      this.formData.depart_date = departTime.format('YYYY-MM-DD')
      this.formData.arrive_time.HH = arriveTime.format('HH')
      this.formData.arrive_time.mm = arriveTime.format('mm')
      this.formData.depart_time.HH = departTime.format('HH')
      this.formData.depart_time.mm = departTime.format('mm')

      this.selectedRoom = {
        room_num: recordData.room_num,
        room_id: recordData.room_id
      }
      this.hotel_id = this.recordData?.hotel_id
    },
    validateForm() {
      const arrive_date = `${this.formData.arrive_date} ${this.formData.arrive_time.HH}:${this.formData.arrive_time.mm}`
      const depart_date = `${this.formData.depart_date} ${this.formData.depart_time.HH}:${this.formData.depart_time.mm}`
      if (depart_date < arrive_date) {
        return this.$t('validation.dateIsAfter', {
          afterDate: 'ngày đi',
          date: 'ngày đến'
        })
      }

      // if (!this.formData.currency_id) {
      //   return this.$t('validation.required', { field: 'tiền tệ' })
      // }
      if (this.formData.num_of_guest <= 0) {
        return this.$t('validation.required', { field: 'số lượng người lớn' })
      }

      if (this.formData.room_type_id == null) {
        return this.$t('validation.required', { field: 'hạng phòng' })
      }

      if (
        (Number(this.formData.num_of_guest) || 0) <
          (Number(this.formData.package_group.number_of_adults) || 0) ||
        (Number(this.formData.child_num) || 0) +
          (Number(this.formData.u5_child_num) || 0) <
          (Number(this.formData.package_group.number_of_children) || 0)
      ) {
        return 'Số lượng trẻ em/người lớn trong combo không hợp lệ'
      }

      if (this.formData.is_combo) {
        if (this.formData.package_group.package_group_id === null) {
          return 'Vui lòng chọn loại Combo'
        }
        const selectedCombo =
          this.comboOptions.filter(
            item => item.id === this.formData.package_group.package_group_id
          )[0] || null
        // console.log('ledoan', selectedCombo)
        if (
          this.formData.package_group.number_of_adults +
            this.formData.package_group.number_of_children >
            selectedCombo?.max_apply_people ||
          this.formData.package_group.number_of_adults <
            selectedCombo?.min_apply_people
        ) {
          // this.selectedRoomType.people_num * 0.6
          return `Số lượng người lớn sử dụng combo chưa đạt tiêu chuẩn`
        }
      }

      for (let i = 0; i < this.formData.daily_price.length; i++) {
        const price = this.formData.daily_price[i]
        if (price.discount_reason && price.discount_reason.length > 50) {
          return this.$t('validation.maxLength', {
            field: 'lý do giảm giá',
            length: 50
          })
        }

        if (price.percent_discount && price.percent_discount > 100) {
          return this.$t('errorMsg.discountPercentMax100')
        } else if (
          price.amount_discount &&
          price.amount_discount > price.price
        ) {
          return this.$t('errorMsg.discountAmountMax')
        }
      }

      return null
    },
    onRemoveRoom() {
      this.formData.room_id = null
      this.selectedRoom = null
    },
    onChangeHotel() {
      if (this.hotel_id == 45 || this.hotel_id == null)
        this.formData.is_bf = false
      else this.formData.is_bf = true
      this.onChangeRoomLevel()
    },
    async onChangeRoomLevel(value = null) {
      console.log('BookingRoomForm', value)
      if (value != null) {
        this.formData.room_type_id = value.room_level_id
        this.hotel_id = value.hotel_id
        this.formData.sub_booking_group_surcharges = []
        this.formData.num_of_guest = value.people_num
        this.formData.num_of_free_card = value.free_card_quantity
        if (this.hotel_id == 45) this.formData.is_bf = false
        else this.formData.is_bf = true
        this.formData.package_group.package_group_id = null
        this.fnGetComboListApi()
      } else {
        this.formData.room_type_id = null
      }
      // this.onChangeHotel()
      await this.getDailyPrice().then(() => this.onRemoveRoom())
    },
    onChangeHourStay(isHourStay) {
      if (!isHourStay) {
        return
      }
      this.formData.depart_date = this.formData.arrive_date
      this.formData.depart_time = {
        HH: '23',
        mm: '00'
      }
    },
    onChangeCurrency(value) {
      // const currency = this.currencyOptions.find(item => item.id === value)
      this.formData.currency_id = value
      // this.formData.exchange_rate = currency.exchange_rate
    },
    async onChangeBookingDate() {
      if (!this.isHydrated) {
        return
      }
      this.resetComboInfo()
      await this.getRoomTypeOptions(
        `${this.formData.arrive_date} ${this.formData.arrive_time.HH}:${this.formData.arrive_time.mm}`,
        `${this.formData.depart_date} ${this.formData.depart_time.HH}:${this.formData.depart_time.mm}`
      )
      await this.getDailyPrice()
      // if (
      //   this.roomLevelOptions.findIndex(
      //     level => level.room_type_id == this.formData.room_type_id
      //   ) === -1
      // ) {
      //   this.formData.daily_price = []
      //   this.formData.room_type_id = null
      //   this.formData.room_id = null
      //   this.selectedRoom = null
      // }
    },
    async getDailyPrice() {
      if (this.formData.room_type_id == null) {
        return
      }
      return generateDailyPriceApi(
        this.formData.arrive_date,
        this.formData.depart_date,
        this.formData.room_type_id,
        this.formData.is_bf
      )
        .then(res => {
          this.formData.daily_price = res.data.map(day => {
            return {
              id: 0,
              price: day.price,
              date: day.date,
              note: null,
              price_code_id: day.price_code_id,
              price_code: day.price_code,
              nett: day.nett,
              currency_id: day.currency_id,
              currency_code: day.currency_code,
              exchange_rate: day.exchange_rate,
              percent_discount: day.percent_discount,
              amount_discount: day.amount_discount,
              discount_reason: this.discountSourceName || day.discount_reason
            }
          })
          this.rootdailyPrice = this.formData.daily_price.map(item => {
            return Object.assign({}, { ...item })
          })
          // Emit event để sync dữ liệu lên parent nếu đang ở chế độ edit
          this.$emit('dailyPriceUpdated', JSON.parse(JSON.stringify(this.formData.daily_price)))
          this.$message({
            type: 'success',
            message: 'Đã cập nhật chi tiết giá ngày.'
          })
        })
        .catch(err => {
          throw err
        })
    },
    async getRoomTypeOptions(arriveDate, departDate) {
      const query = {
        dateFrom: arriveDate,
        dateTo: departDate
      }
      await getBookingGroupAvailableRoomLevelListApi(query)
        .then(res => {
          this.roomLevelOptions = res.data
            .map(type => {
              type.room_type_name = type.room_level_name
              return type
            })
            .sort((level1, level2) => {
              if (level1.hotel_id > level2.hotel_id) {
                return -1
              } else if (level1.hotel_id < level2.hotel_id) {
                return 1
              }
              return 0
            })
        })
        .catch(err => {
          const message = err?.response?.data?.data.message
          this.$message({
            type: 'error',
            message: message
          })
        })
    },
    async getCurrencyOptions() {
      await getAllCurrencyApi().then(response => {
        this.currencyOptions = response.data
        if (this.action === 'create') {
          this.formData.currency_id = this.currencyOptions[0].id
          // this.formData.exchange_rate = this.currencyOptions[0].exchange_rate
        }
      })
    },
    async getHotelOptions() {
      await getAllHotels().then(response => {
        this.hotelOptions = response.data
      })
    },
    async getRoomOptions(roomNumber, hotelId, roomLevelId) {
      const query = {
        roomNumber,
        hotelId,
        roomLevelId
      }
      await getRoomListApi(query).then(response => {
        this.roomOptions = response.data
      })
    },
    async onApplyDateChange() {
      // if (this.action === 'create')
      this.formData.package_group.package_group_id = null
      // console.log('goi bang time')
      this.fnGetComboListApi()
    },
    async fnGetComboListApi() {
      // console.log('aooo', this.formData.package_group)
      if (
        this.formData.package_group.apply_date === null ||
        this.formData.room_type_id === null
      ) {
        return
      }
      // this.selectedCombo = {}
      const payload = {
        applyDate: this.formData.package_group.apply_date,
        roomLevelId: this.formData.room_type_id
      }
      getComboListApi(payload).then(res => {
        this.comboOptions = res.data
      })
    },
    onChangeCombo(val) {
      console.log('hehe', val)
    },
    onChangeEnableCombo() {
      this.formData.package_group = {
        package_group_id: null,
        number_of_adults: 0,
        number_of_children: 0,
        apply_date: null,
        child_price: 0,
        adult_price: 0
      }
    },
    resetComboInfo() {
      this.formData.package_group = {
        package_group_id: null,
        number_of_adults: 0,
        number_of_children: 0,
        apply_date: null
      }
      this.formData.is_combo = false
      this.comboOptions = null
    },
    updateDiscountReason() {
      // Cập nhật discount_reason cho tất cả các dòng trong daily_price
      if (this.formData.daily_price && this.formData.daily_price.length > 0) {
        let hasChange = false
        this.formData.daily_price.forEach((day, index) => {
          // Chỉ cập nhật nếu có giảm giá thực sự
          if (this.discountSourceName && (day.amount_discount || day.percent_discount)) {
            if (day.discount_reason !== this.discountSourceName) {
              this.$set(this.formData.daily_price[index], 'discount_reason', this.discountSourceName)
              hasChange = true
            }
          } else if (!day.amount_discount && !day.percent_discount) {
            // Nếu không có giảm giá, để trống lý do giảm giá
            if (day.discount_reason !== null) {
              this.$set(this.formData.daily_price[index], 'discount_reason', null)
              hasChange = true
            }
          }
        })
        // Emit event nếu có thay đổi
        if (hasChange) {
          this.$emit('dailyPriceUpdated', JSON.parse(JSON.stringify(this.formData.daily_price)))
        }
      }
    }
  }
}
</script>
<style lang="scss">
.ag-theme-balham .ag-row.room-level-row {
  background-color: var(--room-level-background);
  color: var(--room-level-background--hovered);
  font-weight: 500;
  border-color: transparent;
  &:hover {
    background-color: var(--room-level-background--hovered);
    color: white;
  }

  &--green {
    --room-level-background: rgb(22, 101, 52, 0.1);
    --room-level-background--hovered: rgb(22 101 52);
  }
  &--brown {
    --room-level-background: rgb(113, 63, 18, 0.1);
    --room-level-background--hovered: rgb(113 63 18);
  }
  &--purple {
    --room-level-background: rgba(168, 85, 247, 0.1);
    --room-level-background--hovered: rgb(168, 85, 247);
  }
  &--red {
    --room-level-background: rgba(225, 29, 72, 0.1);
    --room-level-background--hovered: rgb(225 29 72);
  }
  &--yellow {
    --room-level-background: rgba(234, 179, 8, 0.2);
    --room-level-background--hovered: rgb(234 179 8);
  }
  &--white {
    // --room-level-background: transparent;
    --room-level-background--hovered: #edf5f1;
    color: black;
    &:hover {
      color: black;
    }
  }
}
.checkbox-wrap input[type='checkbox']:disabled + label:before {
  background-color: #dddfdf !important;
  cursor: not-allowed;
}
</style>
